const AdminBackground = () => {
  return (
    <div className="fixed inset-0 z-0">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 transform rotate-45 translate-x-1/4 -translate-y-1/4 bg-blue-800/30" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 transform -rotate-12 -translate-x-1/4 translate-y-1/4 bg-white/10" />
      <div className="absolute top-1/4 left-1/4 w-px h-80 transform -rotate-45 bg-blue-700" />
      <div className="absolute top-3/4 right-1/4 w-px h-60 transform rotate-45 bg-blue-700" />
      <div className="absolute top-1/2 left-3/4 w-px h-40 transform -rotate-12 bg-blue-700" />
      <div className="absolute top-1/3 right-1/3 w-px h-32 transform rotate-12 bg-blue-700" />
    </div>
  );
};

export default AdminBackground;
